
import { useTheme as useNextTheme } from "next-themes"
import { useEffect, useState } from "react"

export function useTheme() {
  const { theme, setTheme, resolvedTheme, systemTheme } = useNextTheme()
  const [mounted, setMounted] = useState(false)
  
  // Use useEffect to avoid hydration mismatch
  useEffect(() => {
    setMounted(true)
  }, [])
  
  const toggleTheme = () => {
    console.log('Toggling theme from:', resolvedTheme)
    // Force explicit theme value instead of relying on resolvedTheme
    setTheme(theme === "dark" ? "light" : "dark")
    
    // Apply the theme directly to the document for immediate feedback
    if (theme === "dark") {
      document.documentElement.classList.remove('dark')
    } else {
      document.documentElement.classList.add('dark')
    }
  }

  // Only return accurate values after mounting to avoid hydration mismatch
  return {
    theme: mounted ? theme : undefined,
    setTheme,
    resolvedTheme: mounted ? resolvedTheme : undefined,
    systemTheme: mounted ? systemTheme : undefined,
    toggleTheme,
    mounted
  }
}
